import { AppConfig } from "@/config/app.config";

/**
 * Get batch-specific audio files with fallback to defaults
 * @param batch - Optional batch identifier. If not provided, uses localStorage or DEFAULT_BATCH
 * @returns Audio files object with paths resolved for the specified batch
 */
export const getAudios = (batch?: string) => {
  // Get selected batch from localStorage or use provided batch or default
  const selectedBatch = batch || localStorage.getItem("selectedBatch") || AppConfig.DEFAULT_BATCH;

  // Get the batch config
  const batchConfig = AppConfig.BATCHES[selectedBatch];
  
  if (!batchConfig) {
    console.warn(`Batch "${selectedBatch}" not found, using defaults`);
    return AppConfig.DEFAULTS.audios;
  }

  // Merge batch-specific audios with defaults (batch overrides defaults)
  return {
    ...AppConfig.DEFAULTS.audios,
    ...(batchConfig.audios || {}),
  };
};
